import { type ReactNode } from 'react'

import { StatRec } from '@/components/common/Stat'
import { usePage } from '@/components/providers/PageProvider'
import { type StatType } from '@/defs/stat'

import { FeaturedCommonStats } from '../../FeaturedCommon/FeaturedCommonStats/FeaturedCommonStats'

import styles from './FeaturedRecInfo.module.scss'
import { FeaturedRecInfoAlternateNames } from './FeaturedRecInfoAlternateNames/FeaturedRecInfoAlternateNames'

type Props = {
  children?: ReactNode
  stats?: StatType[]
  subtitle?: string
  title: string
}

export const FeaturedRecInfo = ({ children, stats, subtitle, title }: Props) => {
  const { page } = usePage()
  const rec = page?.featured?.rec

  if (!rec || !stats) return null

  return (
    <div className={styles.container}>
      {children}
      <h1 className={styles.heading}>
        <span className={styles.headingMain}>{title}</span>
        {subtitle && <span className={styles.headingSubtitle}>{subtitle}</span>}
      </h1>
      <FeaturedRecInfoAlternateNames />
      <FeaturedCommonStats
        statElements={stats.map((stat) => (
          <StatRec key={stat} rec={rec} stat={stat} />
        ))}
      />
    </div>
  )
}
